import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useRefunds(data = {}) {
  const { enabled = false, params = {} } = data;
  const { privateFetch } = useContext(FetchContext);

  const getRefunds = () => privateFetch.get('/v1/admin/refunds', { params });

  // Include params in query key so react-query re-fetches whenever filters change
  return useQuery(['refunds-list', params], getRefunds, {
    enabled,
    keepPreviousData: true,
  });
}

export default useRefunds;
